// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"c4871a6f","165":"addd687b","204":"70ebf5e6","244":"67e0fde2","278":"275a8079","345":"90e8c74b","346":"fd371440","362":"48e9c36e","393":"e0705fd8","407":"53b9ca0b","424":"0c59fea9","488":"aefbbab9","601":"5ac20d23","842":"cc87876f","903":"ed4ed278","932":"d0c4cd50"}[chunkId] + ".chunk.js";
};